'use client';

import type { Session } from 'next-auth';

import { DynamicLoginScreen } from './dynamic-screen/component';
import { LoginProvider } from './provider/component';
import { LoginScreenEnum } from './provider/enums';

export const LoginPageComponent = ({ session }: { session: Session | null }) => {
  return (
    <LoginProvider initScreen={LoginScreenEnum.login} session={session}>
      <DynamicLoginScreen />
    </LoginProvider>
  );
};
